module.exports = "<div class=pose-image ng-style=\"{'background-image':'url({{$ctrl.AppServices.DataManager.config.settings.assetsPath}}{{$ctrl.options.image}})'}\"></div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/pose-image/pose-image.html
 ** module id = 73
 ** module chunks = 0
 **/